import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    groupUsersEditPaper: {
      width: theme.spacing(60),
    },
    groupUsersEditActionsRoot: {
      padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    },
  })
);
